import React from 'react'
import Index from './Projects/Index'

const App = () => {
  return (
    <div>
      <Index />
    </div>
  )
}

export default App